import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';

export const BuildingStage = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'En Construcción' },
    { value: 2, label: 'A Estrenar' },
    { value: 3, label: 'Usado' }
  ];
  return (
    <div>
      <label>Etapa del Edificio</label>
      <ReactSelect
        name="buildingStage"
        placeholder="-- Seleccione la Etapa del Edificio --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj('buildingStage', e?.value && Number(e.value));
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingStage.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
